import React from 'react';
import { useVisibleTicker } from '../useVisibleTicker';

/* 各产品品牌色（原为 #FF9F43）统一收到强调色：
   五个演示在同一页滚动出现，各用自己的色会让强调色失去指示作用。
   SVG 的 stroke/fill 不吃 CSS 变量的回退链，这里取字面值。 */
const BRAND = '#ff6308';

/** 演示基数：接近真实使用中的一个工作日中段状态 */
const BASE_EARNED = 328.6;
const STEP = 0.02;
const PROGRESS = 0.66;

/**
 * 薪资奖励官 · Apple Watch 表盘模拟。
 *
 * 这是全页唯一带"数字持续跳动"的模拟界面，因为该产品的核心体验就是
 * "抬腕看见每一分钟的价值"——静态截图无法传达这件事，跳动的末位小数可以。
 *
 * 金额用 tabular-nums 等宽数字，否则每次进位都会引起整行宽度抖动。
 */
const WatchSalaryDemo: React.FC = () => {
  const { ref, tick } = useVisibleTicker(200);
  const earned = BASE_EARNED + tick * STEP;

  // 进度环：周长 - 已完成部分，用 strokeDashoffset 表现
  const R = 46;
  const CIRC = 2 * Math.PI * R;

  return (
    <div ref={ref} className="flex justify-center">
      <div className="sx-device sx-device-watch w-[210px] shrink-0">
        <div
          className="relative rounded-[26px] overflow-hidden"
          style={{ background: '#000', aspectRatio: '198 / 242' }}
        >
          {/* 表盘顶部状态栏 */}
          <div className="flex items-center justify-between px-4 pt-3">
            <span className="sx-num text-[10px]" style={{ color: BRAND }}>
              14:26
            </span>
            <span className="sx-dot sx-dot-live" style={{ background: BRAND }} aria-hidden="true" />
          </div>

          {/* 中央进度环 + 实时金额 */}
          <div className="relative flex items-center justify-center mt-1">
            <svg width="112" height="112" viewBox="0 0 112 112" aria-hidden="true">
              <circle cx="56" cy="56" r={R} fill="none" stroke="#1f2228" strokeWidth="6" />
              <circle
                cx="56"
                cy="56"
                r={R}
                fill="none"
                stroke={BRAND}
                strokeWidth="6"
                strokeLinecap="round"
                strokeDasharray={CIRC}
                strokeDashoffset={CIRC * (1 - PROGRESS)}
                transform="rotate(-90 56 56)"
              />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <span className="sx-mono text-[8px] mb-0.5">今日已赚</span>
              <span className="sx-num text-[19px] font-medium text-white leading-none">
                {earned.toFixed(2)}
              </span>
              <span className="sx-mono text-[8px] mt-1">{Math.round(PROGRESS * 100)}% 日进度</span>
            </div>
          </div>

          {/* 小福狸陪伴条：产品的情绪价值内核 */}
          <div className="absolute bottom-0 left-0 right-0 px-3 pb-3">
            <div
              className="flex items-center gap-2 rounded-xl px-2.5 py-2"
              style={{ background: 'rgba(255,159,67,0.1)', border: '1px solid rgba(255,159,67,0.2)' }}
            >
              <span className="text-[13px]" aria-hidden="true">
                🦊
              </span>
              <span className="text-[9px] leading-tight" style={{ color: '#FFD9A8' }}>
                奶茶目标还差 2 小时
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WatchSalaryDemo;
